import Sveip from '@nrk/dh-basis-sveip'

export class ViderenavigasjonSveip extends Sveip {
  connectedCallback() {
    super.connectedCallback()
    this.#startAnimations()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    for (const animation of this.getAnimations({ subtree: true })) {
      animation.cancel()
    }
  }

  #startAnimations() {
    for (const item of this.items) {
      // @ts-ignore
      const timeline = new ViewTimeline({ axis: 'inline', subject: item })

      // eslint-disable-next-line compat/compat
      const effect = new KeyframeEffect(
        item,
        [
          { opacity: 0.2, scale: 0.95, easing: 'ease-in-out' },
          { opacity: 1, scale: 1, easing: 'ease-in-out' },
          { opacity: 0.2, scale: 0.95 },
        ],
        { fill: 'both' },
      )

      // eslint-disable-next-line compat/compat
      const animasjon = new Animation(effect, timeline)

      // @ts-ignore
      animasjon.rangeStart = {
        rangeName: 'cover',
        // eslint-disable-next-line compat/compat
        offset: new CSSMathSum(CSS.percent(50), CSS.px(-330)),
      }

      // @ts-ignore
      animasjon.rangeEnd = {
        rangeName: 'cover',
        // eslint-disable-next-line compat/compat
        offset: new CSSMathSum(CSS.percent(50), CSS.px(330)),
      }

      const images = item.querySelectorAll('figure img')

      // eslint-disable-next-line compat/compat
      const effect2 = new KeyframeEffect(
        images[0],
        [
          { rotate: '0deg', translate: '0px 0px' },
          { rotate: '-1deg', translate: '0px 5px' },
        ],
        { fill: 'both', easing: 'ease-in-out' },
      )

      // eslint-disable-next-line compat/compat
      const animasjon2 = new Animation(effect2, timeline)

      // @ts-ignore
      animasjon2.rangeStart = {
        rangeName: 'cover',
        // eslint-disable-next-line compat/compat
        offset: new CSSMathSum(CSS.percent(50), CSS.px(-330)),
      }

      // @ts-ignore
      animasjon2.rangeEnd = {
        rangeName: 'cover',
        // eslint-disable-next-line compat/compat
        offset: new CSSMathSum(CSS.percent(50), CSS.px(330)),
      }

      // eslint-disable-next-line compat/compat
      const effect3 = new KeyframeEffect(
        images[1],
        [
          { rotate: '0deg', translate: '0px 0px' },
          { rotate: '1deg', translate: '0px -5px' },
        ],
        { fill: 'both' },
      )

      // eslint-disable-next-line compat/compat
      const animasjon3 = new Animation(effect3, timeline)

      // @ts-ignore
      animasjon3.rangeStart = {
        rangeName: 'cover',
        // eslint-disable-next-line compat/compat
        offset: new CSSMathSum(CSS.percent(50), CSS.px(-330)),
      }

      // @ts-ignore
      animasjon3.rangeEnd = {
        rangeName: 'cover',
        // eslint-disable-next-line compat/compat
        offset: new CSSMathSum(CSS.percent(50), CSS.px(330)),
      }

      animasjon.play()
      animasjon2.play()
      animasjon3.play()
    }
  }
}
